
export class FileManagerContentComponent {

  constructor(public sourceType: string) {
  }
}




